/* Sezon Dekor: gift card amount chips. The theme's own <select> stays in the page (hidden) and still drives
   the variant, price and cart; a chip just sets its value and fires the same "change" event. */
(() => {
  function build(root) {
    const sel = root.querySelector('select.product-variant__container--select');
    if (!sel || sel.dataset.sdChips) return;
    sel.dataset.sdChips = '1';
    const row = document.createElement('div');
    row.className = 'sd-chips'; row.setAttribute('role', 'group');
    row.setAttribute('aria-label', (root.querySelector('.sidebar-widget__title') || {}).textContent || 'Vlera');
    const sync = () => row.querySelectorAll('.sd-chip').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.v === sel.value)));
    [...sel.options].forEach(o => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'sd-chip'; b.dataset.v = o.value; b.textContent = o.textContent.trim();
      if (o.disabled) b.disabled = true;
      b.addEventListener('click', () => {
        if (sel.value === o.value) return;
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      row.appendChild(b);
    });
    sel.addEventListener('change', sync);
    sel.parentNode.insertBefore(row, sel);
    root.classList.add('sd-has-chips');
    sync();
    const on = row.querySelector('[aria-pressed="true"]');   // bring the chosen amount into view
    if (on) row.scrollLeft = Math.max(0, on.offsetLeft - 24);
  }
  function init() {
    document.querySelectorAll('.sd-gift').forEach(root => {
      build(root);
      // if the theme ever re-renders the picker, build the chips again
      new MutationObserver(() => build(root)).observe(root, { childList: true, subtree: true });
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
